import { render, staticRenderFns } from "./PsComeDown.vue?vue&type=template&id=b6454120&scoped=true&"
import script from "./PsComeDown.vue?vue&type=script&lang=js&"
export * from "./PsComeDown.vue?vue&type=script&lang=js&"
import style0 from "./PsComeDown.vue?vue&type=style&index=0&id=b6454120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6454120",
  null
  
)

export default component.exports